import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { StyleThemeAdapter } from '../theme.adapter';
import { fetchTheme, fetchThemeFail, fetchThemeSuccess } from './theme.actions';
import { ThemeRequest } from '../theme.model';

@Injectable()
export class ThemeStoreEffects {
  constructor(
    private actions$: Actions,
    private themeAdapter: StyleThemeAdapter,
  ) {}

  loadRequestEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTheme),
      mergeMap(() =>
        this.themeAdapter.fetchTheme().pipe(
          map((themeRequest: ThemeRequest) => {
            if (themeRequest.hasError) {
              return fetchThemeFail({ themeRequest });
            }

            return fetchThemeSuccess({ themeRequest });
          }),
        ),
      ),
    ),
  );
}
